import { render } from "./HypedView.vue?vue&type=template&id=463c63f3&scoped=true&lang=pug"
import script from "./HypedView.vue?vue&type=script&lang=js"
export * from "./HypedView.vue?vue&type=script&lang=js"

import "./HypedView.vue?vue&type=style&index=0&id=463c63f3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463c63f3"]])

export default __exports__